import { Inject, inject, Injectable } from '@angular/core';
import { Resolve, Route } from '@angular/router';
import {
    HomeComponent,
    ProjectsComponent,
    AboutComponent,
    ContactComponent
  } from '@rx-lib/pages';

import { STORE } from './app.store';
import { RouteMapEntry } from '@rx-lib/models';
import { Observable, of } from 'rxjs';
// import { PageIndex } from '@rx-lib/ui';





/* DATA RESOLVER */

@Injectable({ providedIn: 'root' })
export class DataResolver implements Resolve<Observable<RouteMapEntry>> {

  private currentRoute$: Observable<RouteMapEntry> = inject(STORE).select('currentRoute');
    
  resolve = (): Observable<Observable<RouteMapEntry>> => of(this.currentRoute$); 
}


export const appRoutes: Route[] = [
	{
		title: 'Úvod',
      	path: 'uvod',
      	component: HomeComponent,
      	children: undefined,
        data: {
            children: false,
            url: 'uvod',
        }
    },
    // {
    //     title: 'Projekty',
    //     path: 'projekty/:project',
    //     component: ProjectsComponent,
    //     children: [],
    //     data: {
    //         children: true,
    //         // url: 'projekty',
    //     },
    //     resolve: { currentRoute: DataResolver } 
    // },
    {
    	title: 'Projekty',
      	path: 'projekty/:project/:id',
        component: ProjectsComponent,
        children: [],
        data: {
            children: true,
            url: 'projekty',
        },
        resolve: { currentRoute: DataResolver } 
    },
    {
    	title: 'O nás',
      	path: 'o-nas',
      	component: AboutComponent,
      	children: undefined,
        data: {
            children: false,
            url: 'o-nas',
        },
        resolve: { currentRoute: DataResolver } 
    },
    {
    	title: 'Kontakt',
		path: 'kontakt',
		component: ContactComponent,
		children: undefined,
        data: {
            children: false,
            url: 'kontakt',
        },
        resolve: { currentRoute: DataResolver } 
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'uvod'
    },
    {
        path: 'projekty/:project',
        pathMatch: 'full',
        redirectTo: 'projekty/:project/1',
    },
    {
        path: 'projekty',
        pathMatch: 'full',
        redirectTo: () => inject(STORE).get('projekty')[0].path + '/1',
    }

];





 
